<template>
    <form @submit.prevent="unUseAuthTwoFactor">
        <div class="account-body">
            <div class="compo-form-items align-items-center">
                <div class="page-sub-title">2단계 인증이 설정되었습니다</div>
                <div class="page-info">지금부터 지정해주신 위치를 이용할때마다 <br><strong>'휴대폰 혹은 이메일 인증'</strong>을 하셔야합니다.</div>
                <button type="sumit" class="btn-m btn-p w-auto"><strong>사용 중지</strong></button>
            </div>
            <div class="compo-form-items w-100">
                <div class="compo-form-item">
                    <div class="compo-form-name">
                        <p class="compo-form-title">인증수단</p>
                        <p class="compo-form-overview">휴대폰 번호</p>
                    </div>
                </div>
                <div class="compo-form-item">
                    <div class="compo-form-name">
                        <p class="compo-form-title">인증위치</p>
                        <p class="compo-form-overview">로그인 시</p>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
    },

    props: {    
        isAuthTwoFactor: {    // 2단계 인증 사용 여부 
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            // 백엔드에서 가져오는 Data
            phoneNum: '01020012789',                   // 휴대폰 번호
            email: 'krkim@tscientific.co.kr',          // 이메일 주소

            // 
            authReqCode : 'TOW_FACTOR_AUTH',           // 인증요청 타입(2단계 인증)
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexTowFactorAuthCode: state => state.vuexTowFactorAuthCode
        }),
    },

    methods: {
        // 2단계 인증 사용 해지
        unUseAuthTwoFactor(){            
            this.$http({
                method: 'post',
                url: '/api/v1/users/updateTowFactorAuthCode',
                data: {
                    "towFactorAuthCode": 'NONE',
                    userNo: this.userNo
                }
            })
            .then(res => {
                if (res.status == 200 || res.status == 204) {

                    // 2단계 인증 사용여부 전달
                    let result = confirm('2단계 인증을 해지하시겠습니까?');

                    if(result){
                        this.$emit('updateMessageCancel', '2단계 인증이 해제되었습니다.');
                        // 2단계 인증 사용여부 전달
                        this.$store.commit('setVuexTowFactorAuthCode', 'NONE');

                    }else{
                        return;
                    }
                } else {
                    const err = new Error();
                    err.response = res;
                    throw err;
                }
            })
            .catch(err => {
                if (err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.status &&
                    err.response.data.status == 400) {

                    alert(`${err.response.data.message}`);
                    return;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/account.scss';

</style>